import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { BasicError, err, isError, ok } from "@nju/result";
import { IChangePortoutStatusResponse } from "./types";
import { verificationErrorResponse } from "./validators";

interface IFetchTasksProps {
  userId: string;
  taskId: string;
}

export async function changePortoutStatus({
  userId,
  taskId,
}: IFetchTasksProps): Promise<IChangePortoutStatusResponse> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/${userId}/tasks/${taskId}/state`,
    {
      method: "patch",
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
        "accept-language": "pl",
      },
      json: {
        state: "INPROGRESS",
      },
    },
  );

  if (isError(result)) {
    const errorInfo = verificationErrorResponse.safeParse(
      result.err.extra?.json,
    );

    if (
      errorInfo.success &&
      (errorInfo.data.code === "50119" || errorInfo.data.code === "50067")
    ) {
      return err(
        new BasicError({
          message: "Cannot cancel migration",
          code: "EXPIRED",
        }),
      );
    }
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
